export default __webpack_public_path__ + "static/media/checkMark-darkGrey.02543cb9.png";